import { formatNumberInput, InputType } from 'types';
import { IMarginInput } from 'next-common';

interface IMarginDetailsProps {
  margin: IMarginInput;
}

export const MarginCartDetails = (props: IMarginDetailsProps) => {
  const getCalculatedMarginPercentage = (): string => {
    let marginValue = props.margin?.marginPercentage || 0;
    if (marginValue < 1) {
      marginValue = marginValue * 100;
    } else {
      marginValue = marginValue / 100;
    }

    return formatNumberInput(marginValue?.toString(), InputType.FLOAT, 1, true).formatted;
  };

  const formattedMarginPercentage = props.margin?.marginPercentage && getCalculatedMarginPercentage();
  const formattedMarginValue =
    props.margin?.marginValue &&
    formatNumberInput(props.margin?.marginValue.toString(), InputType.INTEGER, 0, true).formatted;
  const formattedCampaignDiscount =
    props.margin?.campaignDiscount &&
    formatNumberInput(props.margin?.campaignDiscount.toString(), InputType.INTEGER).formatted;
  const formattedCampaignImporter =
    props.margin?.campaignImporter &&
    formatNumberInput(props.margin?.campaignImporter.toString(), InputType.INTEGER).formatted;

  return (
    <div className="grid gap-y-6">
      <div id="campaignDiscountOverview" className="grid grid-cols-[14rem_7rem_auto] px-2">
        <p className="font-semibold text-base/[175%]">Rabatt</p>
        <p className="font-semibold text-base/[175%] text-right"></p>
        <p className="font-semibold text-base/[175%] text-right">{formattedCampaignDiscount ?? 0} kr</p>
      </div>

      <div id="campaignImporter" className="grid grid-cols-[14rem_7rem_auto] px-2">
        <p className="font-semibold text-base/[175%]">Importørstøtte</p>
        <p className="font-semibold text-base/[175%] text-right"></p>
        <p className="font-semibold text-base/[175%] text-right">{formattedCampaignImporter ?? 0} kr</p>
      </div>

      <div
        id="totalMarginOverview"
        className="grid grid-cols-[12rem_7rem_auto] px-2 py-4 border-b border-t border-neutralPlus"
      >
        <p className="font-extrabold text-base/[175%]">Total margin</p>
        <p className="font-extrabold text-base/[175%] text-right">{formattedMarginPercentage ?? 0} %</p>
        <p className="font-extrabold text-base/[175%] text-right">{formattedMarginValue ?? 0} kr</p>
      </div>
    </div>
  );
};
